/* Para Al Oum — méga-menu premium : clavier, ARIA, images différées (13/10/2026).
   Complète theme.js (tactile + Échap) sans le remplacer. */
(() => {
  // Tiroir ouvert sur tablette (≤ 1023 px) : theme.js le ferme à chaque « resize » au-delà de 650 px
  // (barre d'adresse qui se replie, etc.). On ignore ces événements tant que le tiroir est ouvert.
  window.addEventListener('resize', (e) => {
    if (window.innerWidth <= 1023 && document.querySelector('.mobile-menu-panel.open')) e.stopImmediatePropagation();
  }, true);

  const nav = document.querySelector('[data-mega-nav]');
  if (!nav) return;
  const items = [...nav.querySelectorAll('[data-mega-item]')];
  if (!items.length) return;
  const toggleOf = (item) => item.querySelector(':scope > [data-mega-toggle]');

  // Charge les vignettes produits seulement quand le panneau est ouvert pour la première fois.
  const loadImages = (item) => {
    if (item.dataset.megaLoaded) return;
    item.dataset.megaLoaded = '1';
    item.querySelectorAll('img[data-mega-src]').forEach((img) => { img.src = img.dataset.megaSrc; img.removeAttribute('data-mega-src'); });
  };
  const sync = (item) => {
    const open = item.classList.contains('is-open') || item.matches(':hover');
    toggleOf(item)?.setAttribute('aria-expanded', String(open));
    if (open) loadImages(item);
  };
  const close = (item) => { item.classList.remove('is-open'); sync(item); };
  const open = (item) => {
    items.forEach((other) => { if (other !== item) close(other); });
    item.classList.add('is-open');
    sync(item);
  };

  items.forEach((item) => {
    // theme.js ajoute/retire .is-open (tactile, clic extérieur, Échap) : on garde aria-expanded à jour.
    new MutationObserver(() => sync(item)).observe(item, { attributes: true, attributeFilter: ['class'] });
    item.addEventListener('mouseenter', () => {
      items.forEach((other) => { if (other !== item && other.classList.contains('is-open')) close(other); });
      sync(item);
    });
    item.addEventListener('mouseleave', () => sync(item));
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(item); });
  });

  nav.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-mega-toggle]');
    if (!toggle) return;
    e.preventDefault();
    e.stopPropagation(); // évite la fermeture immédiate par le gestionnaire global de theme.js
    const item = toggle.parentElement;
    item.classList.contains('is-open') ? close(item) : open(item);
  });

  nav.addEventListener('keydown', (e) => {
    const item = e.target.closest('[data-mega-item]');
    if (!item) return;
    const toggle = toggleOf(item);
    if (e.key === 'Escape' && (item.classList.contains('is-open') || item.matches(':hover'))) {
      e.stopPropagation();
      close(item);
      toggle?.focus();
    } else if (e.key === 'ArrowDown' && (e.target === toggle || e.target.classList.contains('mega-link'))) {
      e.preventDefault();
      open(item);
      item.querySelector('.mega-panel a')?.focus();
    }
  });
})();
